import React from "react";
import HorizontalLinearStepper from "../../components/stepper/stepper";

export default function Event() {
  return (
    <div className="flex flex-col  w-full h-full full_heigth  min-h-screen">
      <div className="flex justify-center w-full">
        <div className="w-full h-full">{<HorizontalLinearStepper />}</div>
      </div>
    </div>
  );
}
